import { createSelector } from 'reselect'

const featureRootSelector = ({ billing }) => billing

const rootSelector = createSelector(
  featureRootSelector,
  ({ promptToRemoveNonRenewingDowngrade }) => promptToRemoveNonRenewingDowngrade || {}
)

export const isSuccessSelector = createSelector(
  rootSelector,
  ({ step }) => step === 'success'
)

export const isFailureSelector = createSelector(
  rootSelector,
  ({ step }) => step === 'failure'
)

export const isLoadingSelector = createSelector(
  rootSelector,
  ({ loading }) => loading
)

export const errorSelector = createSelector(
  rootSelector,
  ({ error }) => error
)
